import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const subscriptionsByDateRange = (startDate, endDate, accessToken) => {
  return axios.get(
    apiUrl + "/report/subscriptions/date-range/" + startDate + "/" + endDate,
    {
      headers: authHeader(accessToken),
    }
  );
};

export const subscriptionsByDate = (date, accessToken) => {
  return axios.get(apiUrl + "/report/subscriptions/day/" + date, {
    headers: authHeader(accessToken),
  });
};

export const gamesByDateRange = (startDate, endDate, accessToken) => {
  return axios.get(
    apiUrl + "/report/games/date-range/" + startDate + "/" + endDate,
    {
      headers: authHeader(accessToken),
    }
  );
};

export const gamesAllTime = (accessToken) => {
  return axios.get(apiUrl + "/report/games/all-time/", {
    headers: authHeader(accessToken),
  });
};

export const usersByDateRange = (startDate, endDate, accessToken) => {
  return axios.get(
    apiUrl + "/report/users/date-range/" + startDate + "/" + endDate,
    {
      headers: authHeader(accessToken),
    }
  );
};

export const usersByDate = (date, accessToken) => {
  return axios.get(apiUrl + "/report/users/day/" + date, {
    headers: authHeader(accessToken),
  });
};
